/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { MainPageEvent, useMainPageDataSelector } from "../../MainUi";
import {
  AppDetailsPageEvent,
  useAppDetailsPageDataSelector,
} from "../AppDetailsPage";
import RatingIcon from "./RatingIcon";

export default function RateAppComponent() {
  const [hoverRating, setHoverRating] = useState<number>(0);

  const dispatch = useDispatch();

  const pageData = useAppDetailsPageDataSelector();
  const mainPageData = useMainPageDataSelector();

  const onMouseEnter = (index: number) => {
    setHoverRating(index);
  };
  const onMouseLeave = () => {
    setHoverRating(0);
  };
  const onSaveRating = (index: number) => {
    if (mainPageData.authState) {
      dispatch({
        type: AppDetailsPageEvent.SUBMIT_APP_RATING,
        payload: {
          appId: pageData.appDetails?.appId,
          rating: index,
          msisdn: mainPageData.appUser.msisdn,
        },
        token: mainPageData.authToken ? mainPageData.authToken : null,
      });
    } else {
      dispatch({
        type: MainPageEvent.SHOW_SIGNIN_MODAL,
      });
    }
    dispatch({
      type: AppDetailsPageEvent.SET_USER_RATING,
      payload: index,
    });
  };

  return (
    <div className="mt-4 col-sm-13">
      <p className="font-weight-bold mt-10 mb-3">Rate this App</p>
      <div className="row">
        <div className="star-rating star-5 mt-2 col-sm-8">
          {[1, 2, 3, 4, 5].map((index) => {
            return (
              <RatingIcon
                key={index}
                index={index}
                rating={pageData.userRating}
                hoverRating={hoverRating}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onSaveRating={onSaveRating}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
